let gaInitialized = false;
const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGoogleAnalytics = () => {
  if (typeof window === "undefined" || gaInitialized) {
    return;
  }

  if (!measurementId) {
    console.warn("GA Measurement ID not found. Google Analytics tracking will be disabled.");
    return;
  }

  try {
    // Load the gtag.js script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", measurementId, {
      cookie_flags: "SameSite=None;Secure",
      send_page_view: false, // Pageview will be fired manually after inhouse_anonymous_id is ready
    });

    gaInitialized = true;
  } catch (error) {
    console.error("Google Analytics initialization failed:", error);
  }
};

export const trackGAEvent = (eventName, properties = {}) => {
  if (!gaInitialized || !window.gtag) {
    return;
  }

  try {
    window.gtag("event", eventName, properties);
  } catch (error) {
    console.error("Unable to track GA event:", { eventName, properties, error });
  }
};

export const identifyGAUser = (userId, properties = {}) => {
  if (!gaInitialized || !window.gtag) {
    return;
  }

  try {
    window.gtag("set", "user_properties", properties);
    window.gtag("config", measurementId, { user_id: userId });
  } catch (error) {
    console.error("Unable to identify GA user:", { userId, properties, error });
  }
};

export const captureGAPageView = (pageName) => {
  if (!gaInitialized || !window.gtag) {
    return;
  }

  try {
    window.gtag("event", "page_view", {
      page_title: pageName || document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  } catch (error) {
    console.error("Unable to capture GA pageview:", { pageName, error });
  }
};
